import { getLocale } from "@pb/utils/locale";
import shouldUseCaching from './shouldUseCaching';
const getCachedArticles = (praConfiguration, articleId) => {
    const { ID, CACHE_ID } = praConfiguration;
    if (!praConfiguration || !articleId || (ID && !shouldUseCaching(ID))) {
        return undefined;
    }
    const locale = getLocale();
    const localizedCacheId = `${CACHE_ID}${locale}`;
    const dataFromStorage = sessionStorage.getItem(localizedCacheId);
    if (dataFromStorage !== null) {
        const parsedData = JSON.parse(dataFromStorage);
        if (parsedData) {
            const articleEntry = parsedData.find((cacheEntry) => cacheEntry.articleId === articleId);
            if (articleEntry) {
                const { data, expires } = articleEntry;
                if (expires > Date.now()) {
                    return data;
                }
            }
        }
    }
    return undefined;
};
export default getCachedArticles;
//# sourceMappingURL=getCachedArticles.js.map